import { UpsellNames, UpsellStatusNames } from '~/enums/Product'

import type { UpsellStatusDescriptor } from '~/types/Product'

function upsellIsHype({ upsell }: UpsellStatusDescriptor): boolean {
  return upsell.name === UpsellNames.HYPE
}

function upsellIsChart({ upsell }: UpsellStatusDescriptor): boolean {
  return upsell.name === UpsellNames.CHARTS
}

/**
 * Find out if a upsell array has hype
 *
 * @param upsellArray - An array of upsells.
 * @returns the found upsell or undefined if not present in the array
 */
export function upsellArrayHasHype(
  upsellArray: UpsellStatusDescriptor[],
): UpsellStatusDescriptor | undefined {
  return upsellArray.find(upsellIsHype)
}

/**
 * Find out if a upsell array has chart
 *
 * @param upsellArray - An array of upsells.
 * @returns the found upsell or undefined if not present in the array
 */
export function upsellArrayHasCharts(
  upsellArray: UpsellStatusDescriptor[],
): UpsellStatusDescriptor | undefined {
  return upsellArray.find(upsellIsChart)
}

/**
 * Get the price for the given upsell
 *
 * @param upsellArray - An array of upsells.
 * @param name - The name of the upsell to get the price for.
 * @returns The price of the upsell or `undefined` if not present in the array.
 */
export function getPriceForUpsell(
  upsellArray: UpsellStatusDescriptor[],
  name: UpsellStatusDescriptor['upsell']['name'],
): number | undefined {
  return (
    upsellArray &&
    upsellArray.find(({ upsell }) => upsell.name === name)?.upsell.price
  )
}

/**
 * Find out if an upsell array has a displayable charts upsell.
 *
 * @param upsellArray - An array of upsells.
 * @returns the found charts upsell or undefined if not present in the array or doesn't match the criteria for display.
 */
export function upsellArrayHasDisplayableCharts(
  upsellArray: UpsellStatusDescriptor[],
) {
  const upsell = upsellArray?.find(upsellIsChart)

  if (
    upsell &&
    (upsell.status === UpsellStatusNames.PAID ||
      upsell.status === UpsellStatusNames.FREE ||
      upsell.status === UpsellStatusNames.GROOVER_PLUS)
  )
    return upsell
}
